import createYCloudIcon from '../createYCloudIcon';

/**
 * @component @name Broccoli
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTNhMyAzIDAgMCAxLTIuMTIxLTUuMTIxIiAvPgogIDxwYXRoCiAgICBkPSJNMTUuNjA2IDE0LjIwNGMtMy41IDEuNS01Ljg5OSA0LjUwMy04Ljg5OSA3LjUwM0ExIDEgMCAwIDEgNiAyMmMtMiAwLTQtMi00LTRhMSAxIDAgMCAxIC4yOTMtLjcwN2MxLjkxMS0xLjkxMSAzLjgyMy0zLjU3OCA1LjM0Ny01LjQ0MSIKICAvPgogIDxwYXRoIGQ9Ik0xNi41NzMgMTQuNzM3QTQgNCAwIDAgMSAxNCAxMSIgLz4KICA8cGF0aAogICAgZD0iTTcuMTQgMTAuOTA3YTQgNCAwIDEgMSAyLjc1Ni03LjQzQTQgNCAwIDAgMSAxNi43IDQuNDhhMiAyIDAgMCAxIDIuODIgMi44MiA0IDQgMCAwIDEgMS4wMDIgNi44MDVBNCA0IDAgMSAxIDEzIDE2IgogIC8+Cjwvc3ZnPgo=) - https://tianjianjun0727.github.io/ycloud-icons/icons/broccoli
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/preact - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Broccoli = createYCloudIcon('broccoli', [
  ['path', { d: 'M10 13a3 3 0 0 1-2.121-5.121', key: '1oqad0' }],
  [
    'path',
    {
      d: 'M15.606 14.204c-3.5 1.5-5.899 4.503-8.899 7.503A1 1 0 0 1 6 22c-2 0-4-2-4-4a1 1 0 0 1 .293-.707c1.911-1.911 3.823-3.578 5.347-5.441',
      key: 'c93qjr',
    },
  ],
  ['path', { d: 'M16.573 14.737A4 4 0 0 1 14 11', key: '1ymr17' }],
  [
    'path',
    {
      d: 'M7.14 10.907a4 4 0 1 1 2.756-7.43A4 4 0 0 1 16.7 4.48a2 2 0 0 1 2.82 2.82 4 4 0 0 1 1.002 6.805A4 4 0 1 1 13 16',
      key: '1kbgad',
    },
  ],
]);

export default Broccoli;
